import React, { useEffect, useState, useContext, useCallback } from "react";
import { Urls } from "../../../../../Urls";
import axios from "../../../../../Axios/Axios";
import Loader from "../../../../Loader";
import { saveMastersApi } from "../../../Utility";
import { toast } from "react-toastify";
import { UserApiContext } from "../../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../../MyCompanyProfileContext";
import { useMixPanelForTracking } from "../../../../../utils/TrackMixPanel";
//import AutoComplete from "../../../../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/AutoComplete/AutoComplete";
import AutoComplete from "../../../../Shared/AutosuggestV2/Autosuggestv2";
import { normalizedValue, sendMailToMasters } from "../../Utility/utility";

/**
 * Step 2 Location Review step for single hop
 * Component for displaying and reviewing location details in step2 for single hop.
 *
 * @param {number} step - current step
 * @param {React.SetStateAction} setStep - sets the current step
 * @param {Array<Object>} uploadedData - Array of uploaded route data
 * @param {React.SetStateAction} setUploadedData - setter to update the uploaded data
 * @param {Array<Object>} routeMasterList - List of master routes
 * @param {React.SetStateAction} setRouteMasterList - setter to update the master route list
 * @param {React.SetStateAction} setAdded_list - setter to the add new routes
 * @param {Array} added_list - Array with new added routes
 * @returns {JSX.Element} rendered LocationDetails component
 */
const RouteDetails = ({
  step = 1,
  setStep = "",
  uploadedData,
  setUploadedData,
  routeMasterList,
  setRouteMasterList,
  setAdded_list,
  added_list,
  company_id,
  superAdmins,
  emailTemplates,
  selectedOrg = "company",
}) => {
  const [uploaded_data, setUploaded_data] = useState([]);
  const [origin_suggestion, setOrigin_suggestion] = useState([]);
  const [destination_suggestion, setDestination_suggestion] = useState([]);
  const [show, setshow] = useState(false);
  const [single_hop_data, setSingle_hop_data] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );

  /**
   * Checks if route point to point or not
   * @param {any} value - route type key
   * @returns {boolean} returns true if route is point to point
   */
  const isRoutePointToPoint = useCallback((value) => {
    return normalizedValue(value) === "pointtopoint";
  }, []);

  // useeffect to fetch suggestions of uploaded lanes
  useEffect(() => {
    const fetchData = async () => {
      if (uploadedData && uploadedData.length > 0) {
        setshow(true);

        // set uploaded data
        setUploaded_data(uploadedData);
        const originList = [];
        const destinationList = [];
        const temp = uploadedData;
        const list1 = [];

        // set single hop routes
        temp.map((data) => {
          if (isRoutePointToPoint(data["Route Type*"])) {
            list1.push(data);
          }
        });
        setSingle_hop_data(list1);

        // map all origins
        temp.map((data) => {
          if (isRoutePointToPoint(data["Route Type*"])) {
            const list = {
              raw_location: String(data["Origin*"] || "").trim(),
              raw_district: String(data["Origin District"] || "").trim(),
              raw_state: String(data["Origin State*"] || "").trim(),
            };

            if (data["Origin Code"]) {
              list.location_code = String(data["Origin Code"]).trim();
              list.company_id = company_id;
            }
            originList.push(list);
          }
        });

        // map all destinations
        temp.map((data) => {
          if (isRoutePointToPoint(data["Route Type*"])) {
            const list = {
              raw_location: String(data["Destination*"] || "").trim(),
              raw_district: String(data["Destination District"] || "").trim(),
              raw_state: String(data["Destination State*"] || "").trim(),
            };
            if (data["Destination Code"]) {
              list.location_code = String(data["Destination Code"]).trim();
              list.company_id = company_id;
            }
            destinationList.push(list);
          }
        });

        // fetch suggestions
        const fetchSuggestions = async (locations, setSuggestion) => {
          const payload = {
            location_list: locations,
          };

          try {
            const response = await axios.post(
              `${Urls.Autocomplete.Post.bulkSuggestion}?bulk_suggestions=true`,
              payload,
            );
            setSuggestion(response.data);
            return response.data;
          } catch (error) {
            console.error("Error fetching suggestions:", error);
          } finally {
            setshow(false);
          }
        };

        setshow(true);

        // fetch suggestions for origin and destination
        const [originSuggestions, destinationSuggestions] = await Promise.all([
          fetchSuggestions(originList, setOrigin_suggestion),
          fetchSuggestions(destinationList, setDestination_suggestion),
        ]);

        // set single hop data
        const updatedSingleHopData = list1.map((data, index) => ({
          ...data,
          origin: originSuggestions[index]?.value[0] || null,
          destination: destinationSuggestions[index]?.value[0] || null,
        }));

        setSingle_hop_data(updatedSingleHopData);
      }
    };

    fetchData();
  }, [uploadedData]);

  /**
   * Function to match location to suggestion
   * @param {string} index - index of location
   * @param {Array<Object>} details -  details of location
   * @param {string} id - location identifier
   * @returns {void} does not return anything
   *
   * Todo - Replace this index matching to location name or code
   */
  const default_location_name = (index, details, id) => {
    if (id === "origin") {
      let origin;
      origin_suggestion.map((suggestion, idx) => {
        if (index === idx) {
          origin = suggestion.value[0];
        }
      });
      return origin;
    } else {
      let destination;
      destination_suggestion.map((suggestion, idx) => {
        if (index === idx) {
          destination = suggestion.value[0];
        }
      });
      return destination;
    }
  };

  /**
   * Saves the location details and updates the Location data state.
   * @param {Array<Object>} other_details - Array of location details to be saved
   */
  const save_details = (other_details) => {
    const errorIndex = single_hop_data.findIndex(
      (details) =>
        !details.origin ||
        !details.origin.location_name ||
        !details.destination ||
        !details.destination.location_name ||
        !details.destination.coordinates ||
        !details.origin.coordinates,
    );

    if (errorIndex !== -1) {
      toast.error(
        `Please select location from dropdown. Error at row number ${errorIndex + 1}.`,
      );
      return;
    }

    let payload = single_hop_data.map((details, index) => {
      if (isRoutePointToPoint(details["Route Type*"])) {
        return {
          origin: details.origin
            ? details.origin
            : default_location_name(index, details, "origin"),
          destination: details.destination
            ? details.destination
            : default_location_name(index, details, "destination"),
          route_type: details["Route Type*"]
            ? details["Route Type*"]
            : "point_to_point",
          distance: details["Distance"] ? details["Distance"] : "",
          duration: details["Duration"] ? details["Duration"] : "",
          // "spot_route": details['Spot Route'] ? JSON.parse(details['Spot Route']) : false,
          spot_route: details["Spot Route"] ? details["Spot Route"] : false,
          route_code: details["Route Code*"],
          no_of_hops: details["No of hops"] ? details["No of hops"] : "",
          sort_order: details["Sort Order"] ? details["Sort Order"] : "",
        };
      }
    });
    if (routeMasterList && routeMasterList.length > 0) {
      TrackMixPanel({
        moduleName: "masters",
        screenName: "masters - other masters- route master",
        data: "none",
        definition:
          "route master details review screen: user clicked on next button",
      });
      let new_list = added_list.concat(payload);
      setAdded_list(new_list);
      //   const prevList = routeMasterList.concat(payload);
      //   setRouteMasterList(prevList);

      setStep(2);
      setshow(true);
      saveMastersApi(company_id, "route", payload, selectedOrg, TrackMixPanel)
        .then((res) => {
          if (res.data.status === false) {
            if (res.data.message.includes("already exist in Route Master")) {
              const codes = res.data.error_codes?.join(", ") || "";
              toast.error(
                `Duplicate route(s): ${codes}. Use a different origin & destination or update the existing route.`
              );
            } else {
              toast.error(res.data.message);
            }
            return;
          } else {
            const prevList = routeMasterList.concat(payload);
            setRouteMasterList(prevList);
            sendMailToMasters(
              "Route Master",
              emailTemplates,
              superAdmins,
              {
                action: "New File Uploaded",
                lane: "",
              },
              setshow,
              userDetails?.user_name || userDetails?.email?.split("@")[0],
            );
            setshow(false);
            toast.success("Data submitted successfully");
          }
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    } else {
      setRouteMasterList(payload);
      const new_list = added_list.concat(payload);
      setAdded_list(new_list);
      saveMastersApi(company_id, "route", payload, selectedOrg, TrackMixPanel)
        .then((res) => {
          setshow(false);
          sendMailToMasters(
            "Route Master",
            emailTemplates,
            superAdmins,
            {
              action: "New File Uploaded",
              lane: "",
            },
            setshow,
            userDetails?.user_name || userDetails?.email?.split("@")[0],
          );
          toast.success("Data submitted successfully");
          setRouteMasterList(payload);
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
      setStep(2);
    }
  };

  // const originSelection = (e, index, data) => {
  //     origin_suggestion.map((suggestion, idx) => {
  //         if (idx === index) {
  //             suggestion.value.map((location, i) => {
  //                 if (location.location_name === e) {
  //                     data.origin = location
  //                 }
  //             })
  //         }
  //     })
  // }

  // const destinationSelection = (e, index, data) => {
  //     destination_suggestion.map((suggestion, idx) => {
  //         if (idx === index) {
  //             suggestion.value.map((location, i) => {
  //                 if (location.location_name === e) {
  //                     data.destination = location
  //                 }
  //             })
  //         }
  //     })
  // }

  return (
    <>
      <div className={`mt-4`} style={{ height: "48vh", overflowY: "auto" }}>
        <Loader show={show} />
        <table className="table table-striped table-borderless">
          <thead>
            <tr>
              <th scope="col" className="text-center">
                Sr No.
              </th>
              <th scope="col" className="text-center">
                Origin
              </th>
              <th scope="col" className="text-center">
                Cleaned Origin
              </th>
              <th scope="col" className="text-center">
                Destination
              </th>
              <th scope="col" className="text-center">
                Cleaned Destination
              </th>
            </tr>
          </thead>
          <tbody>
            {single_hop_data && single_hop_data.length > 0
              ? single_hop_data.map((data, index) => {
                if (isRoutePointToPoint(data["Route Type*"])) {
                  return (
                    <tr>
                      <td className="text-center">{index + 1}.</td>
                      <td className="text-center">
                        {data["Origin*"]}{" "}
                        {data["Origin Code"] && `(${data["Origin Code"]})`}
                      </td>
                      <td className="text-center">
                        <AutoComplete
                          key={`origin_${index}`}

                          module_key="indents"
                          user_identifier={company_id}

                          value={
                            data?.origin?.location_name
                              ? {
                                label: data.origin.location_name,
                                value: data.origin.location_name,
                              }
                              : null
                          }

                          placeholder="Please select a value from dropdown"

                          onChange={(val) => {
                            const updatedData = [...single_hop_data];

                            if (!updatedData[index].origin) {
                              updatedData[index].origin = {};
                            }

                            updatedData[index].origin = {
                              ...updatedData[index].origin,
                              location_name: val,   // typing
                            };

                            setSingle_hop_data(updatedData);
                          }}

                          onSelect={(selectedLocation) => {
                            const updatedData = [...single_hop_data];
                            updatedData[index].origin = selectedLocation; // full object
                            setSingle_hop_data(updatedData);
                          }}

                          searchFields="new_locations"
                        />
                      </td>
                      <td className="text-center">
                        {data["Destination*"]}{" "}
                        {data["Destination Code"] &&
                          `(${data["Destination Code"]})`}
                      </td>
                      <td className="text-center">
                        <AutoComplete
                          key={`destination_${index}`}

                          module_key="indents"
                          user_identifier={company_id}

                          value={
                            data?.destination?.location_name
                              ? {
                                label: data.destination.location_name,
                                value: data.destination.location_name,
                              }
                              : null
                          }

                          placeholder="Please select a value from dropdown"

                          onChange={(val) => {
                            const updatedData = [...single_hop_data];

                            if (!updatedData[index].destination) {
                              updatedData[index].destination = {};
                            }

                            updatedData[index].destination = {
                              ...updatedData[index].destination,
                              location_name: val,   // typing
                            };

                            setSingle_hop_data(updatedData);
                          }}

                          onSelect={(selectedLocation) => {
                            const updatedData = [...single_hop_data];
                            updatedData[index].destination = selectedLocation; // full object
                            setSingle_hop_data(updatedData);
                          }}

                          searchFields="new_locations"
                        />
                      </td>
                    </tr>
                  );
                }
              })
              : null}
          </tbody>
        </table>
      </div>
      <div className="text-center mt-4">
        <div>
          <button
            className="btn btn-secondary mr-3"
            onClick={() => {
              TrackMixPanel({
                moduleName: "masters",
                screenName: "masters - other master - route master",
                data: "none",
                definition:
                  "user clicked back button on route details review screen",
              });
              setStep(0);
            }}
          >
            back
          </button>
          <button
            className="btn btn-success ml-3"
            onClick={() => save_details(uploaded_data)}
          >
            next
          </button>
        </div>
      </div>
    </>
  );
};

export default RouteDetails;
